<div class="h-100 w-100 m-0 row bg-custom-primary">
    <div class="col-md-7 flex flex-row-1 form-container px-4 py-3">
        <div class="d-flex justify-content-between">
            <div class="logo">
                <img [src]="cvaUI_url + '/assets/images/logo.svg'" alt="logo" width="70px">
            </div>
        </div>
        <div class="two-step-form-wrapper d-flex align-items-center justify-content-center">
            <div class="two-step-content text-center">
                <h1 class="two-step-title">Verify your identity</h1>
                <p class="two-step-subtitle">Enter the 6-digit code sent to {{ email }}</p>

                <div *ngIf="showAlert" class="otp-alert otp-alert-error" [@shake]="alert.type === 'error'">
                    {{ alert.message }}
                </div>

                <div class="verification-section">
                    <div class="verification-code">
                        <input *ngFor="let digit of codeArray; let i = index" type="text" maxlength="1"
                            [(ngModel)]="verificationCode[i]" (input)="onInput($event, i)"
                            (keydown)="onKeydown($event, i)" (paste)="onPaste($event)" class="digit-input"
                            pattern="[0-9]*" inputmode="numeric" autocomplete="one-time-code" />
                    </div>

                    <button class="form-btn verify-btn" mat-stroked-button type="button" [disabled]="isVerifying"
                        (click)="verifyOtp()">
                        <span *ngIf="!isVerifying">Verify &amp; Continue</span>
                        <mat-spinner *ngIf="isVerifying" diameter="24"></mat-spinner>
                    </button>

                    <button type="button" class="back-link" (click)="backToLogin()">Entered wrong email?</button>
                </div>
            </div>
        </div>
    </div>
    <div class="h-100 col-md-5 bg-cover position-relative bg-co d-none d-md-block p-0">
        <cva-form-template></cva-form-template>
    </div>
</div>
